/**
 * Factory for creating 3D texture processors, the image3d slice's loader-facing adapter
 * (`resources/formats/image3d/`, ADR-0031). It cuts an image into the slices its **Import
 * sidecar** names, as Godot's layered importer does.
 */
import * as THREE from 'three';
import { createResourceProcessor } from '../createResourceProcessor';
import { decodeImagePixels, getMimeType, isTexturePath } from '../formats/image/textureProcessing';
import { sliceImage } from '../textures/layeredTexels';
import { dataTexture3D } from '../textures/dataTexture3D';
import { readLayeredSlices } from './readLayeredSlices';
import { importTexture3DSlices } from '../../parser/importParser';
export function createTexture3DProcessor(fileEventBus, eventBus, dependencies) {
    return createResourceProcessor({
        fileEventBus,
        eventBus,
        resourceType: 'texture3d',
        readsFile: isTexturePath,
        shouldProcess: (_path, data) => data instanceof ArrayBuffer,
        process: async (path, data) => {
            const slices = await readLayeredSlices({ assetPath: path, dependent: { busType: 'texture3d', key: path }, fileEventBus, dependencies }, importTexture3DSlices, 'a 3D texture');
            const image = await decodeImagePixels(data, getMimeType(path), eventBus.getThreeManager());
            const volume = sliceImage(image, slices);
            if (!volume)
                throw new Error(`${path} is too small for ${slices.horizontal}x${slices.vertical} slices`);
            const { texels, width, height, depth } = volume;
            return dataTexture3D(texels, width, height, depth, THREE.RGBAFormat);
        },
        dispose: (texture) => texture.dispose(),
    });
}
//# sourceMappingURL=createTexture3DProcessor.js.map